import { Box, Tooltip } from "@mui/material";
import theme from "Theme/AppTheme";
import React from "react";
import { components } from "react-select";
import AcxButton from "components/UI/AcxButton";

const CustomOption = (props: any) => {
    if (props.data.onClick) {
        const { onClick, icon, showTopBorder } = props.data;
        return (
            <Box
                sx={{
                    borderTop: showTopBorder
                        ? `1px solid ${theme.palette.gray[300]}`
                        : undefined,
                    padding: showTopBorder
                        ? theme.spacing(1, 0)
                        : theme.spacing(0, 0, 1),
                    display: "flex",
                    width: "100%",
                }}
            >
                <AcxButton
                    sx={{ color: theme.palette.gray[800], border: 0, flex: 1 }}
                    onClick={onClick}
                    startIcon={icon}
                    color="white"
                >
                    {props.label}
                </AcxButton>
            </Box>
        );
    }
    // Options are grouped in the target field dropdowns.
    // No selection is in a group of its own with no label
    // This removes the spacing from the group to keep spacing consistent
    if (props.data.label === "No selection" && props.data.value === "") {
        return (
            <Box
                sx={{
                    margin: theme.spacing(-1, 0),
                }}
            >
                <components.Option {...props} />
            </Box>
        );
    }
    return (
        <Tooltip
            title={
                props.isDisabled ? "This target field is already in use." : ""
            }
            placement="left"
            arrow
        >
            <div>
                <components.Option {...props} />
            </div>
        </Tooltip>
    );
};

export default CustomOption;
